import { render } from "./view_document.vue?vue&type=template&id=47b6fa64"
import script from "./view_document.vue?vue&type=script&lang=js"
export * from "./view_document.vue?vue&type=script&lang=js"

import "./view_document.vue?vue&type=style&index=0&id=47b6fa64&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\tap-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__